import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(() => ({
  tabContainer: {
    display: 'flex',
    width: '95%',
    '& button': {
      fontSize: '13px',
      fontFamily: 'Roboto',
      padding: '15px 26px',
      border: 'none',
      borderRight: '1px solid #c8c8c8',
      cursor: 'pointer',
    },
  },
  tab: {
    backgroundColor: '#d8d8d8',
    '&:hover': {
      backgroundColor: '#c8c8c8',
    },
  },
  selectedTab: {
    backgroundColor: '#f36d2a',
    color: 'white',
  },
  pageTitleBlock: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  content: {
    marginTop: '1rem',
    display: 'flex',
    flexDirection: 'column',
  },
}));

export default useStyles;
